export const LANGUAGE_DART = 'dart';
export const LANGUAGE_DOCKER = 'docker';
export const LANGUAGE_DOT_NET = 'dotnet';
export const LANGUAGE_ELIXIR = 'elixir';
export const LANGUAGE_GOLANG = 'golang';
export const LANGUAGE_JAVA = 'java';
export const LANGUAGE_JAVASCRIPT = 'js';
export const LANGUAGE_NODE = 'node';
export const LANGUAGE_PHP = 'php';
export const LANGUAGE_PYTHON = 'python';
export const LANGUAGE_RUBY = 'ruby';
export const LANGUAGE_RUST = 'rust';
